module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-number-field"
  }, [(_vm.text) ? _c('label', [_vm._v(_vm._s(_vm.text))]) : _vm._e(), _vm._v(" "), (!_vm.readOnly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    ref: "numeric",
    attrs: {
      "placeholder": _vm.placeholder,
      "type": "tel"
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "blur": _vm.onBlurHandler,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      }, _vm.onInputHandler],
      "focus": _vm.onFocusHandler
    }
  }) : _c('span', {
    ref: "readOnly"
  }, [_vm._v(_vm._s(_vm.amount))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-000f57d9","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/inputs/NumberInput.vue
// module id = 1977
// module chunks = 0